import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import HomePage from "@/pages/HomePage";
import ProductPage from "@/pages/ProductPage";
import BlogIndex from "@/pages/BlogIndex";
import ArticlePage from "@/pages/ArticlePage";

function Shell() {
  const location = useLocation();
  const navigate = useNavigate();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      const hash = href.startsWith("/#") ? href.slice(1) : href;
      const el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      if (href.startsWith("/#") && window.location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const target = document.querySelector(hash);
          if (target) lenis.scrollTo(target, { offset: -72 });
        }, 150);
        return;
      }
      lenis.scrollTo(el, { offset: -72 });
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, [navigate]);

  useEffect(() => {
    const scrollTarget = location.state?.scrollTo;
    if (scrollTarget) {
      setTimeout(() => {
        const el = document.getElementById(scrollTarget);
        if (el) lenisRef.current?.scrollTo(el, { offset: -72 });
      }, 120);
    } else {
      lenisRef.current?.scrollTo(0, { immediate: true });
    }
  }, [location.pathname, location.state]);

  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/produk/:id" element={<ProductPage />} />
          <Route path="/artikel" element={<BlogIndex />} />
          <Route path="/artikel/:slug" element={<ArticlePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
